import EnvatoSSO from "@envato/envato-sso"

export default new EnvatoSSO()
